import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import "../assets/css/StatusPages.css";

const Cancel = () => (
  <>
    <Helmet>
      <title>Payment cancelled – Farmer Boaz</title>
      <meta name="robots" content="noindex" />
    </Helmet>
    <div className="status-page">
      <div className="status-card">
        <span className="status-badge is-warning" aria-hidden="true">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            width="1em"
            height="1em"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <circle cx="12" cy="12" r="9" />
            <path d="M12 8v5M12 16.5h.01" />
          </svg>
        </span>
        <h1>Payment was cancelled</h1>
        <p>
          Nothing has been charged. Your cart is still waiting whenever you are ready to finish
          checking out.
        </p>
        <div className="status-actions">
          <Link to="/order-now" className="btn">
            Back to campaigns
          </Link>
          <Link to="/" className="btn btn--ghost">
            Back to home
          </Link>
        </div>
      </div>
    </div>
  </>
);

export default Cancel;
